var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "no-stock-popup-page" }, [
    _c("div", { staticClass: "no-stock-popup" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "order-details" }, [
        _c("p", { staticClass: "order-title" }, [_vm._v("OOS Details")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "no-stock-products-container" },
          _vm._l(_vm.oosProducts, function(product) {
            return _c("div", { key: product.id, staticClass: "oos-product" }, [
              _c("img", { attrs: { src: _vm._f("getProductImage")(product) } }),
              _vm._v(" "),
              _c("div", [
                _c("p", { staticClass: "oos-title" }, [
                  _vm._v(_vm._s(product.title))
                ]),
                _vm._v(" "),
                product.variants
                  ? _c("p", { staticClass: "oos-price" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("moneySaleFormat")(product.variants[0].price)
                        )
                      )
                    ])
                  : _vm._e()
              ])
            ])
          }),
          0
        )
      ]),
      _vm._v(" "),
      _vm.replacements
        ? _c(
            "div",
            { staticClass: "quick-replacements" },
            [
              _c("p", { staticClass: "no-stock-details" }, [
                _vm._v("Pick replacements")
              ]),
              _vm._v(" "),
              _c(
                "VueSlickCarousel",
                {
                  attrs: {
                    infinite: true,
                    arrows: true,
                    slidesToShow: _vm.slidesToShow(),
                    slidesToScroll: _vm.slidesToShow()
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "prevArrow",
                        fn: function(arrowOption) {
                          return [
                            _c("div", [
                              _c("img", {
                                attrs: {
                                  src:
                                    "https://cdn.shopify.com/s/files/1/1363/8433/files/arrow_left.svg?v=1657408648"
                                }
                              })
                            ])
                          ]
                        }
                      },
                      {
                        key: "nextArrow",
                        fn: function(arrowOption) {
                          return [
                            _c("div", [
                              _c("img", {
                                attrs: {
                                  src:
                                    "https://cdn.shopify.com/s/files/1/1363/8433/files/arrow_right.svg?v=1657408648"
                                }
                              })
                            ])
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    619622916
                  )
                },
                [
                  _vm._v(" "),
                  _vm._l(_vm.replacements, function(addonProduct) {
                    return _c(
                      "li",
                      { key: addonProduct.id },
                      [
                        void 0,
                        _vm._v(" "),
                        _c("AddonProductNew", {
                          attrs: {
                            product: addonProduct,
                            cartProducts: _vm.selectedAddonProducts,
                            maxCapacity: _vm.maxCapacity,
                            currentCapacity: _vm.currentCapacity,
                            boxQty: _vm.boxQty,
                            productLimit: _vm.productLimit,
                            addCopy: _vm.addCopy
                          }
                        })
                      ],
                      2
                    )
                  })
                ],
                2
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "actions" }, [
        _c(
          "button",
          {
            staticClass: "happybox-button yellow",
            attrs: { disabled: !_vm.canReplace },
            on: { click: _vm.replaceAndBundle }
          },
          [_vm._v("replace & continue")]
        )
      ]),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "actions bottom-actions" }, [
        _c(
          "button",
          {
            staticClass: "happybox-button purple",
            on: { click: _vm.removeAndContinue }
          },
          [_vm._v("remove items & continue")]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "no-stock-header" }, [
      _c("p", { staticClass: "no-stock-title" }, [_vm._v("Uh Oh...")]),
      _vm._v(" "),
      _c("p", { staticClass: "no-stock-subtitle" }, [
        _vm._v("Something's out of stock")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "separator" }, [
      _c("div", { staticClass: "line-separator" }),
      _vm._v(" "),
      _c("div", { staticClass: "text" }, [_vm._v("OR")]),
      _vm._v(" "),
      _c("div", { staticClass: "line-separator" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }